/* eslint-disable */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import router from './router';
import store from './store';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Message from '@/components/toast/message.js';
import Loading from '@/components/loading/';

Vue.prototype.$message = Message;
Vue.config.productionTip = false;
Vue.prototype.resetSetItem = function (key, newVal) {
    //  实现监听心愿单的增加和减少
    if (key === 'wishTotal') {
        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
                sessionStorage.setItem(k, val);

                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

                // 派发对象
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, newVal);
    }
 };

/* ============
 * vue-i18n
 * ============
 *
 * 🌐 Internationalization plugin for Vue.js https://kazupon.github.io/vue-i18n/
 *
 * {{$t('message.hello')}}
 *
 * `this.$i18n.locale` get language property
 * https://github.com/kazupon/vue-i18n
 */

Vue.use(Loading);
Vue.use(VueI18n);
const messages = {
    En: require('@/lang/en.json'),
    Ja: require('@/lang/ja.json'),
};

const i18n = new VueI18n({
    locale: 'En', // set locale
    messages, // set locale messages
    fallbackLocale: 'En',
});

router.afterEach((to, from) => {
    if (to.name === from.name) return;
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    window.scrollTo(0, 1);
});

/* ============
 * axios
 * ============
 *
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 *
 * https://github.com/mzabriskie/axios
 */
window.axios = require('axios');
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
};

// 全局api接口请求处理
import Api from './api';

window.API = new Api('/');

new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
}).$mount('#app');
